export default function (umbrella) {
  function getHostname() {
    return (window && window.location ? window.location.hostname : '') || '';
  }
  function isLocalhost() {
    var hostname = getHostname();
    return ['localhost', 'lvh.me', '127.0.0.1', '[::1]'].includes(hostname);
  }
  var environment = window.biwEnvironment || '';
  function getEnvironment() {
    if (!environment) {
      if (isLocalhost()) {
        environment = 'qa';
      } else {
        var hostname = getHostname();
        environment = hostname.toLowerCase().split('.').find(function (chunk) {
          return ['qa', 'pprd'].indexOf(chunk) >= 0;
        });
      }
    }
    return environment;
  }
  var domain = window.biwDomain || '';
  function getDomain() {
    if (!domain) {
      if (isLocalhost()) {
        domain = 'biw.cloud';
      } else {
        var hostname = getHostname();
        var subdomains = hostname.split('.');
        domain = subdomains.slice(subdomains.length - 2).join('.');
      }
    }
    return domain;
  }
  function getURL(url) {
    var env = getEnvironment();
    var domain = getDomain();
    url = url.toLowerCase();
    url = url.replace('(env)', env ? env : '');
    url = url.replace('(env.)', env ? "".concat(env, ".") : '');
    url = url.replace('(domain)', domain);
    return url;
  }
  umbrella.isLocalhost = isLocalhost;
  umbrella.getEnvironment = getEnvironment;
  umbrella.getDomain = getDomain;
  umbrella.getURL = getURL;
}
//# sourceMappingURL=environment.js.map